import { StyleCreate, StyleMeta } from '@dicebear/core';
import * as dicebearStyle from './dicebear-style';

// Export the DiceBear style
export const staffMemberAvatars: {
  meta: StyleMeta;
  create: StyleCreate<{
    backgroundColor?: string[];
    shapeColor?: string[];
  }>;
  schema: typeof dicebearStyle.schema;
} = {
  meta: dicebearStyle.meta,
  create: dicebearStyle.create,
  schema: dicebearStyle.schema
};

// Export colors for external use
export { BACKGROUND_COLORS, SHAPE_COLORS } from './colors';


export default staffMemberAvatars;
